import { render, staticRenderFns } from "./MyEvent.vue?vue&type=template&id=49ff68a1"
import script from "./MyEvent.vue?vue&type=script&lang=js"
export * from "./MyEvent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports